<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >     
        <v-card>        
          <template>
  <v-toolbar color="primary" dark>
    <v-toolbar-title class="white--text">Delivery Executives</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items >
      <v-btn flat v-on:click="addExecutive()" :disabled="!vid">Add New</v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>
     <v-card-text style="padding:0;">
        <v-toolbar flat color="white" dense style="margin-bottom:0px;margin-top:0px;">
    <v-btn color="blue" :disabled="selected.length!=1" small @click="editExecutive()" class="white--text"><v-icon>mdi-pencil</v-icon>edit</v-btn>
    <v-btn color="red" :disabled="selected.length!=1"  small @click="deleteExecutive()" class="white--text"><v-icon>mdi-delete</v-icon>delete</v-btn>
    <v-spacer></v-spacer>
    <div style="width:200px;">

      <v-text-field
        v-model="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </div>
  </v-toolbar>
          <v-data-table
            :headers="headers"
            v-model="selected"
            :items="executives"
            :search="search"
            dense
            item-key="id"
            show-select

          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-primary text--darken-3"
                v-text="header.text"
              />
            </template>
             
            <template
              slot="items"
              slot-scope="props"
            >
            <td>
          <v-checkbox
            v-model="props.selected"
            color="primary"
            hide-details

          ></v-checkbox>
        </td>
              <td>{{props.index+1}}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.phoneNumber }}</td>
              <td><span v-if="props.item.bonus_mode=='f'">Rs.</span>{{ props.item.bonus }}<span v-if="props.item.bonus_mode=='%'">%</span></td>
              <td>
                <v-switch
              v-model="props.item.active"
              color="primary"
              class="v-input--reverse"
              style="justify-content:start;"
              hide-details
              @change="updateActive(props.item)"
            >
              <template slot="label">
          Active
        </template>
            </v-switch>
              </td>
            </template>

          </v-data-table>
        </v-card-text>
        </v-card>
      </v-flex>
     <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline text-primary" v-if="mode=='insert'">New Executive</span>
          <span class="headline text-primary" v-else>Update Executive</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" ref="form">
          
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field label="Name*" required :rules="rules.fieldRequired" v-model="executive.name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field label="Phone Number*" :rules="rules.fieldRequired" v-model="executive.phoneNumber"></v-text-field>
                  
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-select
                v-model="executive.bonus_mode"
                :items="[{text:'flat',value:'f'},{text:'percentage',value:'%'}]"
                item-text="text"
                item-value="value"
                label="Bonus Mode*"
                :rules="rules.fieldRequired"
                >
                </v-select>
                  
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field label="Bonus*" :rules="rules.fieldRequired" v-model="executive.bonus"></v-text-field>
                  
              </v-flex>
            </v-layout>
  
          <small>*indicates required field</small>
        </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" flat @click.native="dialog = false">Close</v-btn>
          <v-btn v-if="mode=='insert'" color="blue darken-1" :disabled="!valid" flat @click.native="insertExecutive()">Save</v-btn>
          <v-btn v-else color="primary darken-1" :disabled="!valid" flat @click.native="updateExecutive()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-layout>
  </v-container>
  
</template>

<style type="text/css">
  
</style>
<script>
import api from '../api'
export default {
  data: () => ({
    search:"",
    selected:[],
    headers: [    
    ],
    valid:false,
    dialog:false,
    executive:{},
    mode:"insert",
    executives:[],
    rules:{
      
      fieldRequired:[v => /^(?!\s*$).+/.test(v) || 'Field is required'],
       email: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],

    },
    

  }),
  methods:{
    reload(){
     let loader = this.$loading.show()
      api.get('deliveryExecutives/get').then(r=>{
        this.executives=r.data
        loader.hide();
   }).catch(async err=>{
    loader.hide()
  if(err.message=='Network Error')
    {
      const res = await this.$dialog.confirm({
        text: 'Please check your internet connection and try again',
        title: 'Connection Failed',
        actions: [{ text: 'Cancel', color: 'primary', key: false },{ text: 'Retry', color: 'primary', key: true }]
      })
      if(res)
      {
        this.reload()
      }
      }
      })
    },
    editExecutive() {
       this.executive=Object.assign({},this.selected[0]);
       if(this.executive.photoNumber)
       this.executive.phoneNumber=this.executive.phoneNumber.substr(3)
      this.dialog=true;
      this.mode="edit"
      this.$refs.form.resetValidation()
    },
    addExecutive() {
       this.executive={
        name:"",phoneNumber:"",bonus_mode:'',bonus:'',active:true
      };
      this.dialog=true;
      this.mode="insert"
      this.$refs.form.resetValidation()
    },
    insertExecutive(){
      if(this.$refs.form.validate())
      {
        let loader = this.$loading.show()
            api.post("deliveryExecutives/add",this.executive).then((r)=>{
              loader.hide();
              this.dialog=false
               if(r.data.status=="success")
               {
               this.executives.unshift(r.data.executive)
               }
               else
               {
                this.$dialog.error({text:r.data.message,title:'Failed'})
               }
            }).catch(async err=>{
    loader.hide()
  if(err.message=='Network Error')
    {
      const res = await this.$dialog.confirm({
        text: 'Please check your internet connection and try again',
        title: 'Connection Failed',
        actions: [{ text: 'Cancel', color: 'primary', key: false },{ text: 'Retry', color: 'primary', key: true }]
      })
      if(res)
      {
        this.insertExecutive()
      }
      }
      })
          }
    },
    updateExecutive(){
      if(this.$refs.form.validate())
      {let loader = this.$loading.show()
            api.post("deliveryExecutives/update/"+this.executive.id,this.executive).then((r)=>{
              loader.hide();
          this.dialog=false
          if(r.data.status=='success')
          this.executives[this.executives.findIndex(a=>a.uid==this.this.executive.uid)]=r.data.executive
           else
            this.$dialog.error({title:'error',text:r.data.message})
            }).catch(async err=>{
    loader.hide()
  if(err.message=='Network Error')
    {
      const res = await this.$dialog.confirm({
        text: 'Please check your internet connection and try again',
        title: 'Connection Failed',
        actions: [{ text: 'Cancel', color: 'primary', key: false },{ text: 'Retry', color: 'primary', key: true }]
      })
      if(res)
      {
        this.updateExecutive()
      }
      }
      })
          }
    },
    deleteExecutive(){
        let loader = this.$loading.show()
            api.post("deliveryExecutives/delete/"+this.selected[0].id).then((r)=>{
              this.executives.splice(this.executives.findIndex(a=>a.id==this.selected[0].id),1)
             loader.hide();
             this.dialog=false
            }).catch(async err=>{
    loader.hide()
  if(err.message=='Network Error')
    {
      const res = await this.$dialog.confirm({
        text: 'Please check your internet connection and try again',
        title: 'Connection Failed',
        actions: [{ text: 'Cancel', color: 'primary', key: false },{ text: 'Retry', color: 'primary', key: true }]
      })
      if(res)
      {
        this.deleteExecutive()
      }
      }
      })

    },
    updateActive(v){
      if(v.active)
         {
          let loader = this.$loading.show()
          api.post("deliveryExecutives/activate/"+v.id).then((r)=>{
         loader.hide();
                  }).catch(async err=>{
    loader.hide()
  if(err.message=='Network Error')
    {
      const res = await this.$dialog.confirm({
        text: 'Please check your internet connection and try again',
        title: 'Connection Failed',
        actions: [{ text: 'Cancel', color: 'primary', key: false },{ text: 'Retry', color: 'primary', key: true }]
      })
      if(res)
      {
        this.updateActive(v)
      }
      }
      })
        }
        else
        {
          let loader = this.$loading.show()
          api.post("deliveryExecutives/deactivate/"+v.id).then((r)=>{
         loader.hide();
                  }).catch(async err=>{
    loader.hide()
  if(err.message=='Network Error')
    {
      const res = await this.$dialog.confirm({
        text: 'Please check your internet connection and try again',
        title: 'Connection Failed',
        actions: [{ text: 'Cancel', color: 'primary', key: false },{ text: 'Retry', color: 'primary', key: true }]
      })
      if(res)
      {
        this.updateActive(v)
      }
      }
      })
        }
    }
  },
 watch:{
    vid(){
      this.reload()
    }
  },
  computed:{
vid(){
     return this.$store.state.vid;
    }
  },
  created(){
    if(this.$store.state.vid!=undefined&&this.$store.state.vid!='')
    api.get("deliveryExecutives/get").then(r=>{
      this.executives=r.data
    }).catch(async err=>{
  if(err.message=='Network Error')
    {
      const res = await this.$dialog.confirm({
        text: 'Please check your internet connection and try again',
        title: 'Connection Failed',
        actions: [{ text: 'Cancel', color: 'primary', key: false },{ text: 'Retry', color: 'primary', key: true }]
      })
      if(res)
      {
        this.reload()
      }
      }
      })
    this.headers=[
    {
        sortable: false,
        text: '',
        value: ''
      },
    {
        sortable: false,
        text: 'id',
        value: 'id'
      },
      {
        sortable: false,
        text:'Name' ,
        value: 'name'
      },
      {
        sortable: false,
        text: 'Phone Number',
        value: 'phoneNumber'
      },
      {
        sortable: false,
        text: 'Bonus',
        value: 'bonus'
      },
      {
        sortable: false,
        text: 'Active',
        value: 'active'
      }];
      
      
  }
}
</script>
